import { render, staticRenderFns } from "./PPFiles.vue?vue&type=template&id=b55e1938"
import script from "./PPFiles.vue?vue&type=script&lang=js"
export * from "./PPFiles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports